module.exports = __webpack_public_path__ + "img/bike_idle.1060a1e7.svg";